import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useSearchParams } from "react-router"
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'

import Rightbar from '../cheques/Rightbar'
import { SET_RERENDER } from 'store/rerender/actions'
import { httpOk, GET, POST, FILE_D } from 'helpers/api'
import { findKeyFromArrayByValue, formatDate, formatMoney, returnSign, PAGE_SIZES, buildCashAccountSelectOptions, getAccountSelectProps } from 'helpers/helpers'
import { businessToday, businessMonthStart } from 'helpers/businessDay'

// Назначение «Комиссия агрегатора» (payment_purpose_types.id, миграция add_aggregator_commission)
const AGGREGATOR_COMMISSION_PURPOSE_ID = 33

function Index() {
	const { t } = useTranslation()
	const { organization_id } = useParams()
	const [searchParams] = useSearchParams()

	const reduxAccount = useSelector(state => state.account)
	const dispatch = useDispatch()
	const date = new Date()

	// Переход из уведомления/бейджа: ?pending=1&pos_id=..&highlight=<id оплаты>.
	// Точка берётся из ссылки (уведомление пришло на конкретную точку), период расширяем
	// на 3 месяца назад — иначе оплата может не попасть в дефолтный "текущий месяц".
	const pendingMode = searchParams.get('pending') === '1'
	const highlightPaymentId = searchParams.get('highlight')
	const queryPosId = searchParams.get('pos_id')

	const transactionTypes = [
		{ 'id': 'plus', 'name': t('debit') },
		{ 'id': 'minus', 'name': t('credit') },
	]

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [accounts, setAccounts] = useState([])
	const [showAcceptModal, setShowAcceptModal] = useState(false)
	const [acceptItem, setAcceptItem] = useState({})
	const [showRightBar, setShowRightBar] = useState({
		'cheques': false,
		'documents_in': false,
		'wms_transfer_pos': false,
	})
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		pos_id: queryPosId ? Number(queryPosId) : reduxAccount.pos_id,
		transaction_type: null,
		search: '',
		start_date: formatDate(
			new Date(date.getFullYear(), date.getMonth() - (pendingMode ? 3 : 0), 1),
			'yyyy-MM-dd'
		),
		end_date: businessToday(),
		size: 20,
	})
	const [pagination, setPagination] = useState({
		url: `/report-organizations-history/${organization_id}`,
		size: 20,
		response: null
	})

	function buildFilterParams(activeFilterData = filterData, includePage = true) {
		var urlParams = ""

		if (activeFilterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + activeFilterData.pos_id
		if (activeFilterData.transaction_type)
			urlParams += returnSign(urlParams) + 'transaction_type=' + activeFilterData.transaction_type
		if (activeFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + activeFilterData.search
		if (activeFilterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + activeFilterData.start_date
		if (activeFilterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + activeFilterData.end_date
		if (activeFilterData.size)
			urlParams += returnSign(urlParams) + 'size=' + activeFilterData.size
		if (includePage && activeFilterData.page)
			urlParams += returnSign(urlParams) + 'page=' + activeFilterData.page

		return urlParams
	}

	async function searchWithFilter(passedData = {}) {
		const activeFilterData = passedData.filterData || filterData
		var filterUrl = `/report-organizations-history/${organization_id}`
		var urlParams = buildFilterParams(activeFilterData)
		checkFilter(activeFilterData)

		if (`/report-organizations-history/${organization_id}${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'size': activeFilterData.size, 'response': response.data })
		}

		setFilterData(activeFilterData)
		setDropdownIsOpen(false)
	}

	async function downloadExcelFile() {
		let urlParams = buildFilterParams({ ...filterData }, false)
		urlParams += returnSign(urlParams) + 'excel=true'
		const response = await FILE_D(`/report-organizations-history/${organization_id}${urlParams}`, { loader: true })
		if (httpOk(response)) {
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileUrl = URL.createObjectURL(file)
			const link = document.createElement('a')
			link.href = fileUrl
			link.setAttribute('download', `organization-debts.xlsx`)
			document.body.appendChild(link)
			link.click()
			URL.revokeObjectURL(fileUrl)
		}
	}

	function handleSelectTemplate(item, index) {
		if (!item.entity_id) return

		if (item.entity_type === 'cheques') toggleRightbarCheque(true, item, index)
		// if (item.entity_type === 'documents_in') toggleRightbarDI(true, item, index)
		// if (item.entity_type === 'wms_transfer_pos') toggleRightbarEWTW(true, item, index)
	}

	async function toggleRightbarCheque(boolean = false, item, index) {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy.data.length; i++) {
			dataCopy.data[i]['showSidebar'] = false
		}

		if (boolean && item.entity_type === 'cheques') {
			const response = await GET(`/cheques/${item.entity_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data.data)
				setShowRightBar({ ...showRightBar, 'cheques': true })
			}
		}

		if (boolean && item.entity_type === 'wms_transfer_pos') {
			const response = await GET(`/cheques/${item.entity_id}`, {}, { loader: true })
			if (httpOk(response)) {
				dataCopy.data[index]['showSidebar'] = boolean
				setSelectedItem(response.data.data)
				setShowRightBar(boolean)
			}
		}

		if (!boolean) {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	async function paginate(page) {
		const nextFilterData = { ...filterData, 'page': page }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function handlePageSizeChange(size) {
		const nextFilterData = { ...filterData, size, page: null }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function resetFilter() {
		const nextFilterData = {
			pos_id: reduxAccount.pos_id,
			transaction_type: null,
			search: '',
			start_date: businessMonthStart(),
			end_date: businessToday(),
			size: 20,
			page: null,
		}
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function checkFilter(currentFilterData = filterData) {
		if (
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	// Открыть модалку приёма неподтверждённой оплаты (выбор счёта прихода)
	function toggleAcceptModal(bool = false, item = {}) {
		setAcceptItem({
			pending_payment_id: item.pending_payment_id,
			amount: item.amount,
			note: item.note,
			account_chef_id: null,
		})
		setShowAcceptModal(bool)
	}

	// Принять оплату: деньги приходят на выбранный счёт
	async function acceptPayment() {
		const response = await POST(
			`/organizations-pending-payments/${acceptItem.pending_payment_id}/accept`,
			{
				account_chef_id: acceptItem.account_chef_id,
			},
			{ loader: true }
		)
		if (httpOk(response)) {
			setShowAcceptModal(false)
			searchWithFilter()
			dispatch(SET_RERENDER()) // обновить бейджи незавершённых действий в меню
		}
	}

	// Отклонить оплату: у плательщика деньги вернутся на счёт
	async function rejectPayment(item) {
		const response = await POST(
			`/organizations-pending-payments/${item.pending_payment_id}/reject`,
			{},
			{ loader: true }
		)
		if (httpOk(response)) {
			searchWithFilter()
			dispatch(SET_RERENDER()) // обновить бейджи незавершённых действий в меню
		}
	}

	useEffect(() => {
		getPoses()
		getAccounts()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const accountChefOptions = buildCashAccountSelectOptions(accounts)

	// Статус кросс-логин оплаты (integration_pending_payments): заливка всей ячейки td
	function pendingStatusClass(ps) {
		if (ps === null || ps === undefined) return ''
		const n = Number(ps)
		if (n === 1) return 'bg-success text-white'
		if (n === -2) return 'bg-warning text-dark'
		if (n === -1) return 'bg-danger text-white'
		return ''
	}

	// Строка оплаты, ради которой пришли по ссылке из уведомления — подсвечиваем
	function isHighlighted(item) {
		if (!highlightPaymentId || !item.pending_payment_id) return false
		return String(item.pending_payment_id) === String(highlightPaymentId)
	}

	// Строки, которые долг не двигают: ожидающая (-2) и отклонённая (-1) оплаты, а также
	// пара «оплата + её отмена» — «Всего» у них равно предыдущей строке, поэтому сумму
	// гасим, чтобы её не читали как проведённую.
	// Сторно чека (возврат в работу, удаление) в пару не входит: исходная строка чека
	// не зачёркнута, а сторно долг реально двигает — зачёркнутая сумма читалась как «не
	// проведено», хотя «Всего» по ней менялось
	function outOfChainClass(item) {
		const outOfChain = Number(item.status) < 0 || item.is_cancelled || (item.is_cancellation && item.cancelled_at)
		return outOfChain ? 'text-muted text-decoration-line-through' : ''
	}

	function pendingStatusLabel(ps) {
		if (ps === null || ps === undefined) return ''
		const n = Number(ps)
		if (n === 1) return t('accepted')
		if (n === -2) return t('expected')
		if (n === -1) return t('rejected')
		return ''
	}

	// Отмена проводки историю не переписывает: исходная строка остаётся, рядом ложится
	// встречная. Бейдж вешаем только на отменённую оплату — на встречной строке он был бы
	// вторым почти таким же словом, а её смысл и так виден по примечанию и колонке «Кредит»
	function cancelStatusClass(item) {
		return item.is_cancelled ? 'bg-danger text-white' : ''
	}

	function cancelStatusLabel(item) {
		return item.is_cancelled ? t('cancelled') : ''
	}

	// «Сторно: Karta» → «Отмена оплаты · 07.09.26 20:58»: слово «Сторно» пишется в базу
	// по-русски и клиентам ничего не говорит, а дата прямо указывает на гасимую оплату.
	// Примечание в базе не трогаем — это запись аудита, переводим только показ
	function cancellationNote(item) {
		if (item.cancelled_at) {
			return `${t('cancellation')} · ${formatDate(item.cancelled_at, 'dd.MM.yy HH:mm')}`
		}

		// Сторно чека — не отмена оплаты: долг по чеку гасится целиком, потому что чек
		// вернули в работу или удалили. «Отмена оплаты: возврата чека» читали как возврат
		// на всю сумму чека, хотя из него убрали одну позицию
		const chequeStorno = (item.note || '').match(/^Сторно\s+(возврата|удаления)\s+чека\s*(#\d+)?/i)
		if (chequeStorno) {
			const label = chequeStorno[1].toLowerCase() === 'возврата' ? t('log_messages.cheque_back_to_work') : t('log_messages.cheque_deleted')
			return chequeStorno[2] ? `${label} ${chequeStorno[2]}` : label
		}

		const rest = (item.note || '').replace(/^Сторно\s*:?\s*/i, '')
		return rest ? `${t('cancellation')}: ${rest}` : t('cancellation')
	}

	// Комиссия агрегатора (AggregatorCommissionService): примечание пишется в базу по-русски —
	// «Комиссия Yandex 30% (курьер агрегатора) · чек #123», «Возврат комиссии · чек #123».
	// Как и со сторно, переводим только показ
	function commissionNote(item) {
		const note = item.note || ''
		const cheque = (note.match(/#\d+/) || [''])[0]
		const modeKeys = {
			'курьер агрегатора': 'delivery_mode_aggregator',
			'своя доставка': 'delivery_mode_own',
			'самовывоз': 'delivery_mode_pickup',
		}

		const rate = note.match(/^Комиссия\s(.*?)\s?([\d.]+)%\s*\((.+?)\)/)
		if (rate) {
			const mode = modeKeys[rate[3]] ? t(modeKeys[rate[3]]) : rate[3]
			return `${t('aggregator_commission')} ${rate[1]} ${rate[2]}% · ${mode} · ${t('cheque')} ${cheque}`
		}

		if (/^Возврат комиссии/.test(note)) {
			return `${t('aggregator_commission')} · ${t('return')} · ${t('cheque')} ${cheque}`
		}

		return note
	}

	return (
		<>
			<div className="page-header d-flex text-truncate">
				<h4 className="vertical-center h-100">
					{t('organizations')}
				</h4>
				<div className="vertical-center">
					<i className="uil uil-angle-double-right fz-20"></i>
				</div>
				<div className="vertical-center">
					<h6>{data.organization_name}</h6>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}
								onSearchChange={(search) => {
									const nextFilterData = { ...filterData, search, page: null }
									setFilterData(nextFilterData)
									searchWithFilter({ filterData: nextFilterData })
								}}>
							</FilterSearch>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="d-flex gap-2">
											<div className="form-group w-100">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group w-100">
												<label>{t('transaction_type')}</label>
												<Select
													isClearable
													options={transactionTypes}
													value={transactionTypes.find(option => option.id === filterData.transaction_type) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'transaction_type': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="form-group">
											<label>{t('period')}</label>
											<PeriodPicker
												startDate={filterData.start_date}
												endDate={filterData.end_date}
												onChange={(period) => setFilterData({ ...filterData, ...period })}
												withTime={false}
												minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
												maxDate={new Date(new Date().getFullYear(), 11, 31)}
											/>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter({ filterData: { ...filterData } })}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide-2"
									onClick={() => downloadExcelFile()}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
						<div className="d-flex gap-2">
							<div className="vertical-center">
								<h4><b>{t('amount')}</b>:</h4>
							</div>
							<div className="vertical-center">
								<h5 className="text-end">
									<span className={`${data.total_amount > 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)}
									</span>
								</h5>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.transaction_type &&
									<span className="me-2">
										<b>{t('transaction_type')}: </b>
										{findKeyFromArrayByValue(transactionTypes, 'id', filterData.transaction_type, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('pos')}</th>
									<th style={{ 'width': '10%' }}>{t("payment")}</th>
									<th style={{ 'width': '45%' }}>{t('note')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('debit')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('credit')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('total')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-center">{t('status')}</th>
									<th style={{ 'width': '44px', minWidth: '44px' }} className="text-center">{t('action')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className={`cursor ${(item.showSidebar ? 'table-tr-active' : '')}`}
										style={isHighlighted(item) ? { 'background': 'var(--dark-surface-2, #fff6f6)', 'boxShadow': 'inset 3px 0 0 #dc3545' } : {}}
										onClick={() => handleSelectTemplate(item, index)}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.pos_name}</td>
										<td className="td-ellipsis">{item.account_chef_name}</td>
										<td className="td-ellipsis">
											{item.entity_type === 'wms_transfer_pos' && item.entity_id ?
												<a href={`/service/wms-transfer-pos/preview/${item.entity_id}`}
													target="_blank" rel="noopener noreferrer"
													onClick={(e) => e.stopPropagation()}>
													{t('transfer')} №{item.entity_id}
												</a>
												: item.is_cancellation ? cancellationNote(item)
													: Number(item.payment_purpose_id) === AGGREGATOR_COMMISSION_PURPOSE_ID ? commissionNote(item)
														: item.note
											}
										</td>
										<td className="text-center text-nowrap">{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-end text-nowrap">
											{item.transaction_type === 'plus' &&
												<span className={outOfChainClass(item) || 'text-success'}>{formatMoney(item.amount)}</span>}
										</td>
										<td className="text-end text-nowrap">
											{item.transaction_type === 'minus' &&
												<span className={outOfChainClass(item)}>{formatMoney(item.amount)}</span>}
										</td>
										<td className={`text-end text-nowrap ${item.balance >= 0 ? 'text-success' : 'text-danger'}`}>
											{formatMoney(item.balance)}
										</td>
										<td className={`text-center text-nowrap ${pendingStatusClass(item.pending_status) || cancelStatusClass(item)}`}>
											{pendingStatusLabel(item.pending_status) || cancelStatusLabel(item)}
										</td>
										<td className="text-center" onClick={(e) => e.stopPropagation()}>
											{item.pending_payment_id &&
												<div className="table-dropdown">
													<Dropdown id={`pp-${index}`}>
														<Dropdown.Toggle variant="outline-primary">
															<i className="uil uil-ellipsis-v"></i>
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<div className="table-dropdown-item text-success"
																onClick={() => toggleAcceptModal(true, item)}>
																<i className="uil uil-check"></i>
																{t('accept')}
															</div>
															<div className="table-dropdown-item text-danger"
																onClick={() => rejectPayment(item)}>
																<i className="uil uil-times"></i>
																{t('reject')}
															</div>
														</Dropdown.Menu>
													</Dropdown>
												</div>
											}
										</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr>
									<td colSpan="7" className="text-end fw-bold">{t('total')}</td>
									<td className={`text-end text-nowrap fw-bold ${data.total_amount >= 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)}
									</td>
									<td></td>
									<td></td>
								</tr>
							</tfoot>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}
							showPageSizeSelect
							pageSizeOptions={PAGE_SIZES}
							onPageSizeChange={handlePageSizeChange}>
						</FilterPagination>
					}
				</div>
			</div>

			{showRightBar.cheques &&
				<Rightbar
					showRightBar={showRightBar}
					setShowRightBar={setShowRightBar}
					selectedItem={selectedItem}>
				</Rightbar>
			}

			{/* MODAL ACCEPT PAYMENT */}
			<Modal show={showAcceptModal} animation={false} centered
 onHide={() => setShowAcceptModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('accept')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group">
						<label>{t('amount')}</label>
						<div className="fw-bold fz-18">{formatMoney(acceptItem.amount)}</div>
					</div>
					<div className="form-group">
						<label className="mb-1">{t('account')}<span className="text-danger">*</span></label>
						<Select
							{...getAccountSelectProps(t)}
							options={accountChefOptions}
							value={accountChefOptions.find(option => option.id === acceptItem.account_chef_id) || null}
							onChange={(option) => setAcceptItem({
								...acceptItem,
								'account_chef_id': option ? option.id : null,
							})}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-secondary"
						onClick={() => setShowAcceptModal(false)}>
						{t('cancel')}
					</button>
					<button className="btn btn-primary"
						disabled={!acceptItem.account_chef_id}
						onClick={() => acceptPayment()}>
						{t('accept')}
					</button>
				</Modal.Footer>
			</Modal>
			{/* MODAL ACCEPT PAYMENT */}

		</>
	)
}

export default Index
